var keyboardKeys = {
  enter: 'Enter'
};

export { keyboardKeys };
